import React from 'react';
import {Link, useLocation} from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiPhone, FiMail, FiMapPin, FiLinkedin, FiTwitter, FiInstagram, FiGithub} = FiIcons;

const Footer = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const scrollToAbout = () => {
    if (isHomePage) {
      const element = document.getElementById('about');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer className="bg-slate-900 text-white py-16 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          {/* Company Info */}
          <div className="space-y-4">
            <h3 className="text-2xl font-bold">WeDesignedIt</h3>
            <p className="text-slate-400 leading-relaxed">
              Creating digital experiences that drive results and help businesses thrive in the modern marketplace.
            </p>
            {/* <div className="flex space-x-4">
              {[
                {icon: FiLinkedin, href: '#'},
                {icon: FiTwitter, href: '#'},
                {icon: FiInstagram, href: '#'},
                {icon: FiGithub, href: '#'}
              ].map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-orange-500 transition-colors duration-300"
                >
                  <SafeIcon icon={social.icon} className="text-slate-400 hover:text-white" />
                </a>
              ))}
            </div> */}
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold text-lg mb-6">Services</h4>
            <ul className="space-y-3">
              {[
                {name: 'Web Development', slug: 'web-development'},
                {name: 'Digital Marketing', slug: 'digital-marketing'},
                {name: 'Brand Design', slug: 'brand-design'},
                {name: 'Mobile Solutions', slug: 'mobile-solutions'},
                {name: 'E-commerce', slug: 'e-commerce'},
                {name: 'Consulting', slug: 'consulting'}
              ].map((service) => (
                <li key={service.slug}>
                  <Link
                    to={`/services/${service.slug}`}
                    className="text-slate-400 hover:text-white transition-colors duration-300"
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold text-lg mb-6">Company</h4>
            <ul className="space-y-3">
              <li>
                {isHomePage ? (
                  <button
                    onClick={scrollToAbout}
                    className="text-slate-400 hover:text-white transition-colors duration-300 text-left"
                  >
                    About Us
                  </button>
                ) : (
                  <Link
                    to="/#about"
                    className="text-slate-400 hover:text-white transition-colors duration-300"
                  >
                    About Us
                  </Link>
                )}
              </li>
              <li>
                <Link
                  to="/projects"
                  className="text-slate-400 hover:text-white transition-colors duration-300"
                >
                  Our Work
                </Link>
              </li>
              {/* <li>
                <Link
                  to="/service-areas"
                  className="text-slate-400 hover:text-white transition-colors duration-300"
                >
                  Service Areas
                </Link>
              </li> */}
              <li>
                <Link
                  to="/contact"
                  className="text-slate-400 hover:text-white transition-colors duration-300"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold text-lg mb-6">Get In Touch</h4>
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiPhone} className="text-orange-500" />
                <div>
                  {/* <div className="text-white font-medium">07769061291</div> */}
                  <div className="text-slate-400 text-sm">Mon-Fri 8am-6pm</div>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiMail} className="text-orange-500" />
                <div>
                  <div className="text-white">hello@wedesignedit.co.uk</div>
                  <div className="text-slate-400 text-sm">We'll respond quickly</div>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiMapPin} className="text-orange-500" />
                <div>
                  <div className="text-white">Aylesbury, Buckinghamshire</div>
                  <div className="text-slate-400 text-sm">United Kingdom</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="text-slate-400 text-sm">
            © {new Date().getFullYear()} WeDesignedIt. All rights reserved.
          </div>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link
              to="/terms-of-service"
              className="text-slate-400 hover:text-white text-sm transition-colors duration-300"
            >
              Terms of Service
            </Link>
            <Link
              to="/privacy-policy"
              className="text-slate-400 hover:text-white text-sm transition-colors duration-300"
            >
              Privacy Policy
            </Link>
            <Link
              to="/cookie-policy"
              className="text-slate-400 hover:text-white text-sm transition-colors duration-300"
            >
              Cookie Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;